import { DateTime } from 'luxon'

import { UserError } from '@/common/error'

import type { VolunteerActivityType } from '@/queries/constants'
import type { UserContextType } from '@/client/context/user'

import {
  AUTOMATICALLY_LOGGED_VOLUNTEER_ACTIVITIES_SET,
  VOLUNTEER_ACTIVITY_TO_LABEL,
} from './constants'
import { getVolunteerActivityTrackerStartDate } from './getVolunteerActivityTrackerStartDate'

export function validateActivityCanBeManuallySubmitted(type: VolunteerActivityType): void {
  if (AUTOMATICALLY_LOGGED_VOLUNTEER_ACTIVITIES_SET.has(type)) {
    throw new UserError({
      type: 'validation',
      externalMessage: `You cannot manually log volunteer activities of type "${VOLUNTEER_ACTIVITY_TO_LABEL[type]}"-- these are automatically logged.`,
    })
  }
}

export function validateUserCanSubmitNonTeamVolunteerActivity(
  user: UserContextType,
  type: VolunteerActivityType
): void {
  const trackerStartDate = getVolunteerActivityTrackerStartDate(user)
  if (type === 'coda-hours' && DateTime.fromISO(user.createdAt) > trackerStartDate) {
    throw new UserError({
      type: 'validation',
      externalMessage: `Only users that joined before ${trackerStartDate.toLocaleString(
        DateTime.DATE_SHORT
      )} have the option to submit volunteer activities of this type.`,
    })
  }
}
